export const ReminderType: { [key: number]: string } = {
  0: 'interview',
  1: 'monitor',
};
